// import Bg from '../../../../public/icons/hero-bg1.jpg';
import { useState} from "react";
import SellerService from "../../../services/seller.service";
import {Bounce, toast} from "react-toastify";
const GetInTouch = () => {
  const [formData, setFormData] = useState({name: "",mobileNo: "",description: ""});

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

const handleSubmit = (event) => {
  event.preventDefault();
  const payload={};
  payload.name = formData.name;
  payload.mobileNo = formData.mobileNo;
  payload.description = formData.description;
  SellerService.enquirySeller(payload).then((response)=>{
      if(response && response.data){
          setFormData({name: "",mobileNo: "",description: ""});
          toast.success('Enquiry Submitted Successfully ', {
              position: "top-right",
              autoClose: 5000,
              closeOnClick: true,
              theme: "light",
              transition: Bounce,
          });
      }else {
          toast.error('Error On Enquiry Submission ', {
              position: "top-right",
              autoClose: 5000,
              closeOnClick: true,
              theme: "light",
              transition: Bounce,
          });
      }
  }).catch((err)=> console.log(err))
}
  return (
    <div className="pt-10 pb-16">
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="h-full w-full flex-1 basis-[18rem]">
          <img
            src={"images/icons/hero-bg1.jpg"}
            alt=""
            className="w-full h-full"
          />
        </div>
        <div className="flex-1 basis-[18rem] bg-secondary py-6 !text-slate-200">
          <div className="max-w-[350px] w-full mx-auto bg-[#0a5076] p-3 rounded-lg">
            <h1 className="text-lg font-semibold">Get in touch</h1>
            <p>
              For more inquiries or deals, just conatct us using the form below,
              we will contact you back!
            </p>
            <div className="mt-4">
              <form onSubmit={handleSubmit}>
              <input
                type="text"
                className="w-full px-2 py-1 border-none rounded-md outline-none bg-secondary"
                placeholder="Your name.."
                id="name" 
                name="name" 
                value={formData.name}
                onChange={handleChange}
              />
              <input
                type="text"
                className="w-full px-2 py-1 mt-3 border-none rounded-md outline-none bg-secondary"
                placeholder="Your mobile number.."
                id="mobileNo" 
                name="mobileNo" 
                value={formData.mobileNo}
                onChange={handleChange}
              />
              <textarea
                type="text"
                className="w-full p-2 mt-3 border-none rounded-md outline-none bg-secondary"
                rows={3}
                placeholder="Your message.."
                id="description" name="description" value={formData.description} onChange={handleChange}
              ></textarea>
              <button className="w-full mt-4 btn btn-primary" type="submit">submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
